import type { FC } from 'react';

import { Wrapper } from './styled';

export const OverviewWrapper: FC = ({ children }) => {
    return <Wrapper>{children}</Wrapper>;
};
